module.exports = "/_next/static/images/ftg-c56b975da4d12ed3ec134060b621a394.jpg";